/**
 * 考试模版章节
 * @author jzhu
 * @date 2020-04-14
 */

import React from 'react'
import {connect} from 'dva'
import _ from 'lodash'
import {modelUtils} from '@/utils'
import {utils_tool, component_tool, framework_tool} from '@/tool'

const {WizContainer} = framework_tool
let {Session} = utils_tool
import {ChapterPreview, LookPreview, BankQuestionLook} from '../../../online'
import ModalDescriptionView from './componests/modalDescriptionView'

import classnames from 'classnames'
import './style.less'

const {
  WizSpin,
  WizButton,
  WizRow,
  WizCol,
  WizNotice,
  WizIcon,
  WizTypography,
  WizInput,
  WizModalForm,
  WizModal,
  WizAlert,
  WizTable,
  WizDropdown,
  WizMenu,
  WizInputNumber,
  WizCustomSteps,
  WizTooltip
} = component_tool
import {WizBraftEditorPlus, WizTableForm} from '../../../common'

import {
  staticwizTabelColumns,
  dynamicWizTableColumns,
  dynamicWizModalFormColumns,
} from './columns'

const WizText = WizTypography.Text
const WizItem = WizMenu.Item


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/examTemplate/examTemplateChapterUpd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateChapterUpd', record)
      } else {
        record = Session.get('examTemplateChapterUpd') || {}
      }
    } else if (history.location.pathname === '/online/examTemplate/examTemplateChapterAdd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examTemplateChapterAdd', record)
      } else {
        record = Session.get('examTemplateChapterAdd') || {}
      }
    }
  }
  return record
}

class ExamTemplateChapter extends WizContainer {
  componentName = 'examTemplateChapter'

  constructor(props) {
    super(props)
    const record = getParamRecord(props.history)
    this.state = {
      id: record.id,
      pathUrl: record.pathUrl,
      record: {},
      currentIndex: -1, //当前选中章节项的索引
      data: [], //所有的章节信息
      questionTabelForm: [],//选择题目tabel中的数据
      categoryTabelForm: [],//分类tabel中的数据
      dynamicWizTableInfo: [],
      questionKey: new Date().getTime(),
      previewnKey: new Date().getTime(),
      lookModalKey: new Date().getTime(),
      chaptersKey: new Date().getTime(),
      lookModalFormVisible: false,//题目预览显示状态
      lookBankQUestionVisible: false,//题目查看状态
      bankQUestionData: {},//题目查看状态
      questionVisible: false,//题目是否显示状态
      categoryVisible: false,//题目分类是否显示状态
      previewVisible: false,//题目查看显示状态
      text: null,//章节提示信息

    }
    this.categoryType = 'create'//分类类型初始未新增点击修改时
    this.type = 'static'//分类类型初始未新增点击修改时
    this.count = 0//符合题型的题目数
    this.scoreCount = 0 //题目总分
  }

  //题目类型对应
  _getValue(type, key) {
    const values = {
      type: {
        0: '单选题',
        1: '多选题',
        2: '判断题',
        3: '填空题',
        4: '主观题',
        6: '文件上传题',
        7: '排序题',
      },
      difficulty: {
        0: '低',
        1: '中',
        2: '高',
      },
      chapter: {
        0: '综合',
        1: '固定',
        2: '随机',
      }
    }
    return values[type][key]
  }

  _componentDidMount() {
    const {id} = this.state
    this.doActions([
      {
        path: 'examTemplate/chapterInfo',
        payload: {
          key: 'examTemplateChapter',
          apiParams: {id}
        }
      }
    ])
  }

  _render() {
    let {examTemplateLoading} = this.props
    let wizCustomStepsProps = {
      header: [
        {title: '考试信息'},
        {title: '考试章节'}
      ],
      current: 1,
      content: this._stepView(),
      footer: null
    }
    return <WizSpin tip={'加载中'} spinning={examTemplateLoading}>
      <WizCustomSteps {...wizCustomStepsProps} />
    </WizSpin>

  }

  _onLookBankQuestion(record) {
    this.setState({
      bankQUestionData: record,
      lookBankQUestionVisible: true,
    })
  }

  _stepView() {
    return (
      <>
        <div className='chapter-page'>
          <WizRow>
            <WizCol span={7} className='chapter-col'>
              {this._renderChapterMenu()}
            </WizCol>
            <WizCol span={17}>
              {this._renderChapterInfo()}
            </WizCol>
          </WizRow>
        </div>
        {this._renderFooter()}
      </>
    )
  }

  //新增章节
  handleMenuClick(e) {
    const {key} = e
    const {data} = this.state
    let nextData = Object.assign([], data)
    if (key === 'static') {
      nextData.push({type: 1, order: data.length})
    } else if (key === 'dynamic') {
      nextData.push({type: 2, order: data.length})
    } else if (key === 'multiple') {
      nextData.push({type: 0, order: data.length})
    }
    this.setState({data: nextData})
  }

  //章节移动事件
  handleMove(flag) {
    const {record, currentIndex, data} = this.state
    if (!data || !data.length || !data[0]) {
      WizNotice.warn('请选中章节再移动');
      return false;
    }
    if (!this._checkChapter(record)) return false
    if (flag === -1) {
      //上移
      if (currentIndex !== 0) {
        const temp = data[currentIndex]
        data[currentIndex] = data[currentIndex - 1]
        data[currentIndex - 1] = temp
        this.setState({
          data,
          record: temp,
          currentIndex: currentIndex - 1
        })
      } else {
        const filterData = data.concat([data.shift()])
        this.setState({
          data: filterData,
          record: filterData[filterData.length - 1],
          currentIndex: filterData.length - 1
        })
      }
    } else if (flag === 1) {
      //下移
      if (!this._checkChapter(record)) return false
      if (currentIndex !== data.length - 1) {
        const temp = data[currentIndex]
        data[currentIndex] = data[currentIndex + 1]
        data[currentIndex + 1] = temp
        this.setState({
          data,
          record: temp,
          currentIndex: currentIndex + 1
        })
      } else {
        const filterData = [data.pop(), ...data]
        this.setState({
          data: filterData,
          record: filterData[0],
          currentIndex: 0
        })
      }
    }
  }

  //章节删除按钮点击事件
  handleDelete() {
    const {record, data,currentIndex} = this.state
    if (!this._checkChapter(record)) return false
    const filterData = data.filter((val,index )=> index !== currentIndex).map((val,index )=>{
      val['order'] = index
      return val
    });
    this.setState({
      data: filterData,
      record: {},
      currentIndex: -1
    })
  }

  //章节按钮校验
  _checkChapter = record => {
    if (record.order < 0) {
      WizNotice.warn('请选择章节')
      return false
    }
    return true
  }

  //模版章节列表 - 左侧
  _renderChapterMenu() {
    const menu = (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        <WizItem key='static'>固定章节</WizItem>
        <WizItem key='dynamic'>随机章节</WizItem>
        <WizItem key='multiple'>综合章节</WizItem>
      </WizMenu>
    )
    const {record, data,currentIndex} = this.state
    return (
      <div className='chapter'>
        <div className='chapter-title'>{'考试章节'}</div>
        <div className='chapter-body'>
          <div className='operate'>
            <WizDropdown overlay={menu}>
              <WizButton type='link'>
                <WizIcon className='icon-add' type='plus-circle'/>
              </WizButton>
            </WizDropdown>
            <WizButton type='link' onClick={() => this.handleMove(-1)}>
              <WizIcon className='icon-circle' type='up-circle'/>
            </WizButton>
            <WizButton type='link' onClick={() => this.handleMove(1)}>
              <WizIcon className='icon-circle' type='down-circle'/>
            </WizButton>
            <WizButton type='link' onClick={() => this.handleDelete()}>
              <WizIcon className='icon-delete' type='delete'/>
            </WizButton>
          </div>
          <ul className='chapter-items'>
            {this._renderChapters(record, data,currentIndex)}
          </ul>
        </div>
      </div>
    )
  }

  //章节部分点击事件
  handleClick = (val, index) => {
    this.setState({
      record: val,
      questionTabelForm: val.questionTabelForm || [],
      categoryTabelForm: val.categoryTabelForm || [],
      currentIndex: index,
      text: null,
    })
  }

  //章节列表
  _renderChapters(record, data = [],currentIndex) {
    if (data.length) {
      return data.map((val, index) => {
        let {title, type, order} = val
        let className = classnames(
          'chapter-item',
          index === currentIndex? 'active' : ''
        )
        return (
          <li key={order} className={className} onClick={() => this.handleClick(val, index)}>
            <span className='badge'>{this._getValue('chapter', type)}</span>
            {title}
          </li>
        )
      })
    }
    return null
  }

  //模版章节信息 - 右侧
  _renderChapterInfo() {
    let {currentIndex, record} = this.state
    let {type} = record
    let rightInfo = null
    let titleModalForm = null
    let textInfo = '[' + this._getValue('chapter', type) + '题目章节]'
    if (currentIndex !== -1) {
      titleModalForm = this._titleModalForm()
      if (type === 1) {
        rightInfo = this._renderStaticTable()
      } else if (type === 2) {
        rightInfo = this._renderDynamicTable()
      } else if (type === 0) {
        rightInfo = this._renderMultipleTable()
      } else {
        textInfo = ''
      }
    } else {
      textInfo = ''
    }
    return (
      <div className='chapter-info'>
        <div className='chapter-info-title'>
          <WizText className='title'>
            {'章节信息'}
            <WizText className='contnet'>
              {textInfo}
            </WizText>
          </WizText>
        </div>
        <div className='chapter-info-body'>
          {titleModalForm}
          {rightInfo}
        </div>
      </div>
    )
  }

  //固定章节名称change事件
  _handleTitleChange() {
    const {record, data, currentIndex} = this.state
    if (event && event.target) {
      if (currentIndex !== -1 && data[currentIndex]) {
        data[currentIndex]['title'] = event.target.value
        data['title'] = event.target.value
        let errorMsg = this.titleValidate(event.target.value)
        //静态章节set静态章节的reocrd
        this.setState({
          chaptersKey:new Date().getTime(),
          record: {...record, title: event.target.value},
          text: errorMsg,
        })

      }
    }
  }

  //固定章节每题分数change事件
  _handleScoreChange(value) {
    const {record, data, currentIndex} = this.state;
    let copyData = Object.assign([], data)
    if (currentIndex !== -1 && data[currentIndex]) {
      let convertValue = value ? value : 0
      copyData[currentIndex]['score'] = convertValue
      copyData['score'] = convertValue
      let errorMsg = this.scoreValidate(convertValue)
      this.setState({
        data: copyData,
        chaptersKey:new Date().getTime(),
        record: {...record, score: convertValue},
        text: errorMsg,
      })
    }
  }

  _handleDescriptionChange(value) {
    const {record, data, currentIndex} = this.state;
    let copyData = Object.assign([], data)
    if (currentIndex !== -1 && data[currentIndex]) {
      let convertValue = value || ''
      copyData[currentIndex]['description'] = convertValue
      copyData['description'] = convertValue
      this.setState({
        data: copyData,
        chaptersKey:new Date().getTime(),
        record: {...record, description: convertValue},
        text: convertValue.length > 5000 ? '章节描述最多5000字符' : ''
      })
    }
  }



  _titleModalForm() {
    const {questionTabelForm, categoryTabelForm, record, text} = this.state
    let questionTotal = 0
    let sourceTotal = 0
    let style = null
    let errorMsg = text || this.titleValidate(record.title) || this.scoreValidate(record.score)
    if (errorMsg) {
      style = {color: 'red'}
    } else if (record.score|| record.score==0) {
      sourceTotal = questionTabelForm.length * record.score
      questionTotal = questionTabelForm.length
      if (categoryTabelForm) {
        categoryTabelForm.forEach(form => {
          questionTotal = questionTotal + form.total * 1
          sourceTotal = sourceTotal + form.total * record.score
        })
      }
    }

    return (
      <>
        <div className='form-control'>
          <div className='form-title'><WizText strong>名称</WizText></div>
          <div style={{width: 180}} className="form-input">
            <WizInput
              key={record.order}
              defaultValue={record.title}
              maxLength={10}
              onChange={event => this._handleTitleChange(event)}
              placeholder='请输入章节名称'/>
          </div>
        </div>
        <div className='form-control'>
          <div className='form-title'><WizText strong>每题分数</WizText></div>
          <div className='form-input'><WizInputNumber
            style={{'width': '180px'}}
            max={99.5}
            key={record.order}
            defaultValue={record.score}
            value={record.score}
            onChange={event => this._handleScoreChange(event)}
            placeholder='请输入分数'/></div>
        </div>
        <div className="form-control">
          <div className="form-title"><WizText strong>章节描述 </WizText></div>
          <div className="form-input"><ModalDescriptionView key={new Date().getTime()} value={record?.description} onChange={e=>this._handleDescriptionChange(e)}/></div>
        </div>


        <div style={{marginTop: 15}}>
          <WizText style={style}
                   strong>{!errorMsg ? '共' + questionTotal + '题,总分' + sourceTotal + '分' : errorMsg}  </WizText>
        </div>
      </>)
  }

  _selectItem = (item) => {
    item.typeChar = this._getValue('type', item.type)
    return (
      <WizRow>
        <WizCol>
          <WizTooltip title={item.typeChar + '  ' + item.number} placement="topLeft" >{item.typeChar + '  ' + item.number}</WizTooltip>
        </WizCol>
      </WizRow>
    )
  }
  //固定章节
  _renderStaticTable() {
    const {questionVisible, data,currentIndex,previewVisible, questionTabelForm, categoryTabelForm, lookBankQUestionVisible, record, questionKey, previewnKey, bankQUestionData,text} = this.state

    let questionIdList = data?.map((val, index) => {
      if(index!=currentIndex){
       return val?.questionTabelForm?.map(p => p.id) || []
      }
      return []
    })||[];
    let notInQuestionIds = _.flatMap(questionIdList).join(',')
    let initialValue = questionTabelForm.map(p => p.id)
    const questionConfig = WizTableForm.Config.question(this, {apiParams: {state: 1, notInQuestionIds},path:'bankQuestion/normalListByPage'})
    let key = 'static_' + record.order
    let wizTableFormProps = {
      key: questionKey,
      ...questionConfig,
      visible: questionVisible,
      initRows: questionTabelForm,
      value: initialValue,
      onSubmit: this._questionSubmit,
      onCancel: this._questionCancel,
      renderValue: this._renderBtn,
      selectItem :this._selectItem
    }
    let wizTableProps = {
      key: key + '_table',
      columns: staticwizTabelColumns(this),
      dataSource: questionTabelForm
    }
    let wizModalProps = {
      title: '题目查看',
      width: 900,
      visible: previewVisible,
      onOk: () => this.setState({previewVisible: false}),
      onCancel: () => this.setState({previewVisible: false})
    }
    let previewProps = {
      key: previewnKey,
      chapterCategoryInfoList: categoryTabelForm,
      questionIds: questionTabelForm,
      title: record.title,
      score: record.score,
      description: record.description,
    }
    return (
      <>
        <div>
          <WizTableForm {...wizTableFormProps} />
          <WizButton
            onClick={() => {
              let errorMsg = text ? text : this.titleValidate(record.title)
              errorMsg = errorMsg ? errorMsg : this.scoreValidate(record.score)
              if (errorMsg) {
                wizNotice.error(errorMsg)
              } else if (questionTabelForm && questionTabelForm.length > 0) {
                this.setState({previewVisible: true, previewnKey: new Date().getTime()})
              } else {
                wizNotice.error("请设置章节题目后查看")
              }
            }}
            style={{marginLeft: 15, marginTop: 15, marginBottom: 15}}
          >
            查看题目
          </WizButton>
        </div>
        <div>
          <WizTable {...wizTableProps} />
          <WizModal {...wizModalProps} >
            <ChapterPreview {...previewProps} />
          </WizModal>
          <WizModal destroyOnClose

                    footer={null}
                    key={new Date().getTime()}
                    width={700} title={"题目预览"}
                    visible={lookBankQUestionVisible}
            // onOk={() => {this.setState({lookBankQUestionVisible: false})}}
                    onCancel={() => {
                      this.setState({lookBankQUestionVisible: false})
                    }}
          >
            <BankQuestionLook record={bankQUestionData}
                              key={this.state.bankQUestionData || this.state.bankQUestionData.id || 0}

                              changeModal={() => {
                                this.setState({lookBankQUestionVisible: false})
                              }}/>
          </WizModal>
        </div>
      </>)
  }

  _renderBtn = () => {
    return (
      <WizButton
        icon='plus'
        type='primary'
        onClick={() => this.addQuestionEvent()}
        style={{marginTop: 15, marginBottom: 15}}
      >
        添加题目
      </WizButton>
    )
  }

  _renderDynamicTable() {
    const {categoryVisible, record, categoryTabelForm, questionTabelForm, dynamicWizTableInfo, previewVisible, previewnKey,text} = this.state
    let key = 'dynamic_' + record.order
    let wizTableFormProps = this._getModalDynamicProps(dynamicWizTableInfo, categoryVisible, record.id)
    let wizModalProps = {
      title: '题目查看',
      width: 900,
      visible: previewVisible,
      onOk: () => this.setState({previewVisible: false}),
      onCancel: () => this.setState({previewVisible: false})
    }
    let previewProps = {
      key: previewnKey,
      chapterCategoryInfoList: categoryTabelForm,
      questionIds: questionTabelForm,
      title: record.title,
      score: record.score,
      description: record.description,
    }
    let wizTableProps = {
      key: key + '_table',
      columns: dynamicWizTableColumns(this, record['score']),
      dataSource: categoryTabelForm
    }
    return (
      <>
        <div>
          <WizButton
            icon='plus'
            type='primary'
            onClick={() => this.addCategoryEvent()}
            style={{marginTop: 15, marginBottom: 15}}
          >
            选择题目分类
          </WizButton>
          <WizButton
            onClick={() => {
              let errorMsg = text ? text : this.titleValidate(record.title)
              errorMsg = errorMsg ? errorMsg : this.scoreValidate(record.score)
              if (errorMsg) {
                wizNotice.error(errorMsg)
              } else if (categoryTabelForm && categoryTabelForm.length > 0) {
                this.setState({
                  previewVisible: true,
                  previewnKey: new Date().getTime()
                })
              } else {
                wizNotice.error("请设置章节题目后查看")
              }
            }}
            style={{marginLeft: 15, marginTop: 15, marginBottom: 15}}
          >
            查看题目
          </WizButton>
        </div>
        <WizModalForm {...wizTableFormProps} />
        <WizModal {...wizModalProps} >
          <ChapterPreview {...previewProps} />
        </WizModal>
        <div>
          <WizTable {...wizTableProps} />
        </div>
      </>
    )
  }

  /**
   * 获取表单模态框属性（添加随机抽题章节内容）
   */
  _getModalDynamicProps = (record, visible, id) => {
    return {
      key: 'dynamic_' + record.order + '_form',
      title: '选择题目分类',
      record,
      rowKey: 'id',
      showNum: false,
      selectType: 'checkbox',
      isScroll: false,
      visible: visible,
      columns: dynamicWizModalFormColumns(this, record),
      modalOpts: {
        width: 600
      },
      onCancel: () => this.setState({categoryVisible: false}),
      onSubmit: values => {
        const {categoryTabelForm} = this.state
        let copyForm = Object.assign([], this.state.categoryTabelForm)
        if (values.total && values.total > this.count) {

          wizNotice.error('抽题总数大于符合题目数')
          return false
        }
        let inArray = false
        let copyInfo = {
          key: categoryTabelForm.length,
          categoryIds: values['questionCategory'][0]['value'],
          id: values.id,
          order: values.order,
          total: values.total,
          type: values.type,
          typeTitle: this._getValue('type', values.type),
          difficulty: values.difficulty,
          difficultyTitle: this._getValue('difficulty', values.difficulty),
          questionCategoryTitle: values['questionCategory'][0]['parentTitle'],
          questionCategory: values['questionCategory'],
        }
        //新增
        if (!values['order'] && values['order'] !== 0) {
          for (let i = 0; i < copyForm.length; i++) {
            //题目分类与题型相同的情况
            if (copyForm[i]['questionCategory'][0]['value'] === values['questionCategory'][0]['value']
              && copyForm[i]['type'] === values['type'] && copyForm[i]['difficulty'] === values['difficulty']) {
              wizNotice.error('同一题目分类不能存在相同的题型')
              return false
            }
          }
          copyInfo = {...copyInfo, order: copyForm.length}
          inArray = false
          //修改
        } else {
          for (let i = 0; i < copyForm.length; i++) {
            //题目分类与题型相同的情况
            if (values['order'] !== copyForm[i]['order']) {
              if (copyForm[i]['questionCategory'][0]['value'] === values['questionCategory'][0]['value']
                && copyForm[i]['type'] === values['type'] && copyForm[i]['difficulty'] === values['difficulty']) {
                wizNotice.error('同一题目分类不能存在相同的题型')
                return false
              }
            } else {
              copyForm[i] = copyInfo
              inArray = true
            }
          }
        }
        if (!inArray) {
          copyForm.push(copyInfo)
        }

        this.setState({
          //record: {},
          categoryTabelForm: copyForm,
          categoryVisible: false
        })
      }
    }
  }

  _renderFooter() {
    const {data, id, lookModalKey, lookModalFormVisible} = this.state
    let titleCount = 0
    let scoreCount = 0
    if (data && data instanceof Array && data.length > 0) {
      data.forEach((value, index) => {
        if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
          titleCount = titleCount + value['questionTabelForm'].length * 1
          let pattern = /^(([1-9][0-9]*)|(([0]\.\d{1,1}|[1-9][0-9]*\.\d{1,1})))$/

          if (value['score'] && pattern.test(value['score'])) {
            scoreCount = scoreCount + (value['questionTabelForm'].length * value['score'])
          }
        }
        if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
          value['categoryTabelForm'].forEach((categoryTabel, key) => {
            titleCount = titleCount + categoryTabel['total'] * 1
            if (value['score']) {
              scoreCount = scoreCount + (categoryTabel['total'] * value['score'])
            }
          })
        }
      })
    }
    this.scoreCount = scoreCount
    return (
      <>
        <div className='table-row'>
          <div className='outline-font'>考试概要</div>
        </div>
        <div className='div-outline'>
          {this.outlineView(data.length, '总章节数', {color: '#3D80E3'})}
          <span className='separator'/>
          {this.outlineView(titleCount, '总题目数', {color: '#3DE3D5'})}
          <span className='separator'/>
          {this.outlineView(scoreCount, '总分数', {color: '#E3773D'})}
        </div>
        <div className='form-btns row-item table-row' style={{textAlign: 'center'}}>
          <WizButton title="上一步" onClick={e => this.prev(id)}>上一步</WizButton>
          <WizButton title='保存' type='primary' onClick={e => this.saveChapter()}>保存</WizButton>
          <WizButton title="预览" onClick={e => this.lookPreviewInfo()}>预览</WizButton>
          <WizButton title='重置' onClick={e => this.reset()}>重置</WizButton>
          <WizModal width={1200} title="考试预览" visible={lookModalFormVisible}
                    footer={<WizButton onClick={e => this.setState({lookModalFormVisible: false})}>关 闭</WizButton>}
                    onCancel={() => {
                      this.setState({lookModalFormVisible: false})
                    }}>
            <LookPreview key={lookModalKey} record={data} id={id} lookType='examTemplate'
                         score={scoreCount}/>
          </WizModal>
        </div>
      </>
    )
  }

  propsAndStateOnChange = {
    questionTabelForm: this._questionTabelForm.bind(this),
    categoryTabelForm: this._categoryTabelForm.bind(this),
    saveExamReturn: this._saveExamReturn.bind(this),
    chapterInfo: this._chapterInfo.bind(this),
    examTemplateInfo: this._examTemplateInfo.bind(this)
  }

  prev(examTemplateId) {
    this.doActions([
      {
        path: 'examTemplate/getExamTemplateById',
        payload: {
          key: 'examTemplate@getById',
          apiParams: {id: examTemplateId}
        }
      }
    ])
  }

  _examTemplateInfo(nextProps, nextState) {
    let record = nextProps.location.record
    if(!record){
      record = nextProps.examTemplateInfo.data
    }
    let pathname = 'examTemplateDetailAdd'
    if (this.state.pathUrl === 'examTemplate/updateExamTemplate') {
      pathname = 'examTemplateDetailUpd'
    }
    let {examTemplateInfo} = nextProps
    let data = examTemplateInfo?.data
    record['categoryType'] = data?.categoryType
    record['totalScore'] = data?.totalScore
    if (examTemplateInfo && examTemplateInfo['success']){
      this.jumpPage(
        'replaceAndDelCrumb',
        '/online/examTemplate/'+pathname,
        {id: this.state.id,...record}
      )
      return true;
    }
  }

  _saveExamReturn(nextProps, nextState) {
    let {saveExamReturn} = nextProps
    if (saveExamReturn && saveExamReturn['success']) {
      wizNotice.success(saveExamReturn['msg'])
      this.jumpPage('replaceAndDelCrumb', '/online/examTemplate')
      return true
    } else {
      wizNotice.error(saveExamReturn && saveExamReturn['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _chapterInfo(nextProps, nextState) {
    let chapterInfo = nextProps['chapterInfo']
    this._updateStateForChapterInfo(chapterInfo, nextState)
    return true
  }

  _updateStateForChapterInfo(chapterInfo, nextState = {}) {
    if (chapterInfo && chapterInfo['success']) {
      let data = []
      if (chapterInfo['data'] && chapterInfo['data'] instanceof Array) {
        //data = Object.assign([],chapterInfo['data'])
        chapterInfo.data.forEach((v, index) => {
          let value = {...v}
          value['order'] = index
          if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
            value['questionTabelForm'].forEach((tabel, key) => {
              tabel['typeChar'] = this._getValue('type', tabel['type'])
              tabel['difficultyTitle'] = this._getValue('difficulty', tabel['difficulty'])
              tabel['order'] = key
              tabel['id'] =tabel['id']
            })
          }
          if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
            value['categoryTabelForm'].forEach((categoryTabel, key) => {
              let categoryIds = categoryTabel['categoryIds']
              let categoryNames = categoryTabel['categoryNames']
              let ownCactegoryInfo = [{
                key: categoryIds,
                title: categoryNames,
                parentTitle: categoryNames,
                label: categoryNames,
                value: categoryIds
              }]
              categoryTabel['questionCategory'] = ownCactegoryInfo
              categoryTabel['questionCategoryTitle'] = categoryNames
              categoryTabel['difficultyTitle'] = this._getValue('difficulty', categoryTabel['difficulty'])
              categoryTabel['typeTitle'] = this._getValue('type', categoryTabel['type'])
              categoryTabel['order'] = key

            })
          }
          data.push(value)
        })
      }

      nextState.data = data
      if (data && data.length) {
        let val
        let currentIndex = this.state.currentIndex
        if (currentIndex === -1 || currentIndex >= data.length) {
          val = data[0]
          currentIndex = 0
        } else {
          val = data[currentIndex]
        }
        if (val) {
          nextState.record = val
          nextState.questionTabelForm = val.questionTabelForm ? val.questionTabelForm : []
          nextState.categoryTabelForm = val.categoryTabelForm ? val.categoryTabelForm : []
          nextState.currentIndex = currentIndex
          nextState.text = null
        }
      } else {
        nextState.record = {}
        nextState.questionTabelForm = []
        nextState.categoryTabelForm = []
        nextState.currentIndex = -1
        nextState.text = null
      }
    }
    return nextState
  }

  _questionTabelForm(nextProps, nextState) {
    if (nextState.currentIndex !== -1) {
      nextState.record['questionTabelForm'] = nextState.questionTabelForm
      nextState.data[nextState.currentIndex]['questionTabelForm'] = nextState.questionTabelForm
    }
    return true
  }

  _categoryTabelForm(nextProps, nextState) {
    if (nextState.currentIndex !== -1) {
      nextState.record['categoryTabelForm'] = nextState.categoryTabelForm
      nextState.data[nextState.currentIndex]['categoryTabelForm'] = nextState.categoryTabelForm
    }
    return true
  }


  //选择题目分类按钮事件
  addCategoryEvent = () => {
    this.setState({
      dynamicWizTableInfo: [],
      categoryVisible: true,
    })
    this.categoryType = 'create'
  }

  //选择题目按钮事件
  addQuestionEvent = () => {
    this.setState({
      questionVisible: true,
      questionKey: new Date().getTime(),
    });
  }

  //选择题目弹出框取消按钮事件
  _questionCancel = (obj, e) => {
    this.setState({
      questionVisible: false,
    })
  }

  //选择题目弹出框确定按钮事件
  _questionSubmit = (obj, e) => {
    if (obj['valueRows'] && obj['valueRows'] instanceof Array && obj['valueRows'].length > 0) {

      obj['valueRows'].forEach((key, index) => {
        key['order'] = index
        key['typeChar'] = this._getValue('type', key['type'])
        key['difficultyTitle'] = this._getValue('difficulty', key['difficulty'])
        if (!key['questionType']) {
          key['questionType'] = 0
        }
      });
    }
    this.setState({
      questionVisible: false,
      questionTabelForm: obj['valueRows']
    })
  }

  //题目分类编辑
  editRow(record) {
    //const { categoryTabelForm } = this.state
    this.setState({
      dynamicWizTableInfo: record,
      categoryVisible: true
    })

  }

  //题目分类删除
  deleteDynamicRow(record) {
    const {categoryTabelForm} = this.state

    let forms = []
    categoryTabelForm.forEach(e => {
      if (e['order'] !== record.order) {
        forms.push(e)
      }
    })
    this.setState({
      categoryTabelForm: forms,
    })

  }

  //题目表单行删除
  deleteRow(record) {
    const {questionTabelForm} = this.state

    let forms = []
    questionTabelForm.forEach(e => {
      if (e['order'] !== record.order) {
        forms.push(e)
      }
    })

    this.setState({
      questionTabelForm: forms,
    })
  }

  titleValidate(value) {
    let errorMsg = null
    let pattern = /^[^\s]*$/
    if (value) {
      if (pattern.test(value)) {
      } else {
        errorMsg = '章节名称包含空格'
      }
    } else {
      errorMsg = '章节名称不能为空'
    }
    return errorMsg
  }

  scoreValidate(value) {
    let errorMsg = null
    let pattern = /^(([0-9][0-9]*)|(([0]\.5|[1-9][0-9]*\.5)))$/
    if (pattern.test(value)) {
      if (value > 100) {
        errorMsg = '每题分数必须小于100'
      }
    } else {
      errorMsg = '每题分数必须大于等于0且为0.5的倍数'
    }
    return errorMsg
  }

  //综合章节form
  _renderMultipleTable() {
    const {record, currentIndex, data} = this.state
    let copyRecord = Object.assign({}, record)
    let form
    if (record.tabelType === 'dynamic') {
      form = this._categoryModalForm()
    } else {
      form = this._questionModalForm()
    }
    return (
      <>
        <div style={{marginTop: 15, marginBottom: 15}}>
          <WizButton.Group>
            <WizButton type={copyRecord.tabelType !== 'dynamic' ? 'primary' : 'default'} onClick={() => {
              copyRecord.tabelType = 'static'
              data[currentIndex] = copyRecord
              this.setState({record: copyRecord})
            }}
            >
              固定题目
            </WizButton>
            <WizButton type={copyRecord.tabelType === 'dynamic' ? 'primary' : 'default'}
                       onClick={() => {
                         copyRecord.tabelType = 'dynamic'
                         data[currentIndex] = copyRecord
                         this.setState({record: copyRecord})
                       }}
            >
              随机抽题
            </WizButton>
          </WizButton.Group>
        </div>
        {form}
      </>
    )

  }

  //随机抽题form
  _categoryModalForm() {
    const {record, categoryTabelForm} = this.state
    let count = 0
    let score = 0
    if (categoryTabelForm && categoryTabelForm instanceof Array && categoryTabelForm.length > 0) {
      count = categoryTabelForm.map(p => p['total']).reduce((prev, next) => prev + next)
      if (record['score']) {
        score = record['score'] * count
      }
    }
    let message = `共${count}题,共${score}分`
    return (
      <>

        <WizAlert message={message} type='info' showIcon/>
        {this._renderDynamicTable()}
      </>
    )
  }

  //固定章节form
  _questionModalForm() {
    const {record, questionTabelForm} = this.state
    let count = 0
    let score = 0
    if (questionTabelForm && questionTabelForm instanceof Array && questionTabelForm.length > 0) {
      count = questionTabelForm.length
      if (record['score']) {
        score = record['score'] * count
      }
    }
    let message = `共${count}题,共${score}分`
    return (
      <>

        <WizAlert message={message} type='info' showIcon/>
        {this._renderStaticTable()}
      </>
    )
  }

  lookPreviewInfo() {
    let data = this.state.data
    let errorCount = 0
    if (data && data.length) {
      data.forEach(e => {
        let errorMsg = e['text'] ? e['text'] : this.titleValidate(e['title'])
        errorMsg = errorMsg ? errorMsg : this.scoreValidate(e['score'])
        let num = 0
        if (errorMsg) {
          errorCount++
          wizNotice.error(errorMsg)
        } else if (e['type'] === 0) {
          if (e['questionTabelForm'] && e['questionTabelForm'].length > 0) {
            num += e['questionTabelForm'].length
          }
          if (e['categoryTabelForm'] && e['categoryTabelForm'].length > 0) {
            num += e['categoryTabelForm'].length
          }
          if (num === 0) {
            errorCount++
            wizNotice.error('综合章节' + e['title'] + '不存在对应的固定题目信息或抽题信息')
          }
        } else if (e['type'] === 1 && !(e['questionTabelForm'] && e['questionTabelForm'].length > 0)) {
          errorCount++
          wizNotice.error("固定章节" + e['title'] + "题目为空，请设置题目!")
        } else if (e['type'] === 2 && !(e['categoryTabelForm'] && e['categoryTabelForm'].length > 0)) {
          errorCount++
          wizNotice.error("随机章节" + e['title'] + "题目为空，请设置题目!")
        }
      })
    } else {
      errorCount++
      wizNotice.error("章节为空，请设置!")
    }
    if (errorCount <= 0) {
      this.setState({
        lookModalFormVisible: true,
        lookModalKey: new Date().getTime()
      })
    }
  }

  reset() {
    let _nextState = this._updateStateForChapterInfo(this.props.chapterInfo)
    this.setState({ ..._nextState })
  }

  saveChapter() {
    const {data, id} = this.state
    let fitterValues = {}
    fitterValues['id'] = id
    fitterValues['chapterInfoList'] = []
    if (this.scoreCount > 1000) {

      wizNotice.error('考试总分不能大于1000')
      return false
    }
    for (let index = 0; index < data.length; index++) {
      let record = data[index]
      let chapterInfo = {}
      chapterInfo['id'] = record['id']
      let titleMsg = this.titleValidate(record['title'])
      if (titleMsg) {

        this.handleClick(data[index], index)
        wizNotice.error(titleMsg)
        return false
      } else {
        chapterInfo['title'] = record['title']
      }
      let scoreMsg = this.scoreValidate(record['score'])
      if (scoreMsg) {
        this.handleClick(data[index], index)
        wizNotice.error(scoreMsg)
        return false
      } else {
        chapterInfo['score'] = record['score']
      }
      if (record['type'] || record['type'] === 0) {
        chapterInfo['type'] = record['type']
      } else {
        this.handleClick(data[index], index)
        wizNotice.error('无效的章节类型')
        return false
      }
      chapterInfo['order'] = index
      //固定章节
      let multipleHaveInfo = false
      if (chapterInfo['type'] === 1 || chapterInfo['type'] == 0) {
        if (record['questionTabelForm'] instanceof Array && record['questionTabelForm'].length > 0) {
          multipleHaveInfo = true
          chapterInfo['questionIds'] = record['questionTabelForm'].map(p => {
            return {questionId: Math.abs(p['id']), questionType: p['questionType'],difficulty: p['difficulty']}
          })
        } else if (chapterInfo['type'] == 1) {
          this.handleClick(data[index], index)
          wizNotice.error('【' + record['title'] + '】章节不存在题目信息')
          return false
        }
        //随机章节
      }
      if (chapterInfo['type'] === 2 || chapterInfo['type'] == 0) {
        chapterInfo['chapterCategoryInfoList'] = []
        if (record['categoryTabelForm'] instanceof Array && record['categoryTabelForm'].length > 0) {
          multipleHaveInfo = true
          record['categoryTabelForm'].forEach((val, index) => {
            if (val.questionCategory instanceof Array && val['questionCategory'].length > 0) {
              chapterInfo['chapterCategoryInfoList'].push({
                id: val.id,
                total: val.total,
                difficulty: val.difficulty,
                type: val.type,
                order: index,
                categoryId: val['questionCategory'][0]['value'],
              })
            } else {
              this.handleClick(data[index], index)
              wizNotice.error('【' + record['title'] + '】章节所选分类信息异常')
              return false
            }
          })
        } else if (chapterInfo['type'] == 2) {
          this.handleClick(data[index], index)
          wizNotice.error('【' + record['title'] + '】章节不存在题目分类信息')
          return false
        }
      }
      if (chapterInfo['type'] === 0 && multipleHaveInfo === false) {
        this.handleClick(data[index], index)
        wizNotice.error('【' + record['title'] + '】综合章节不存在对应的固定题目信息或抽题信息')
        return false
      }
      if(record?.['description']?.length > 5000) {
        this.handleClick(data[index], index)
        wizNotice.error('【' + record['title'] + '】章节描述最多5000个字符')
        return false
      }
      chapterInfo['description'] = record?.['description']

      fitterValues['chapterInfoList'].push(chapterInfo)

    }
    this.doActions([
      {
        path: 'examTemplate/saveChapter',
        payload: {
          key: 'saveExamTemplateChapter',
          apiParams: {
            ...fitterValues
          }
        }
      },
    ])
  }

  /**概要内容 */
  outlineView(count, title, countColor) {
    return (
      <span className='outline-view'>
                <div className='outline-count' style={countColor}>{count}</div>
                <div className='outline-title'>{title}</div>
            </span>
    )
  }

}

const
  mapStateToProps = (state, ownProps) => {
    const {examTemplate} = state
    const chapterInfo = modelUtils.getModelEntity(examTemplate, 'examTemplateChapter')
    const saveExamReturn = modelUtils.getModelEntity(examTemplate, 'saveExamTemplateChapter')
    const examTemplateInfo = modelUtils.getModelEntity(examTemplate,'examTemplate@getById')
    const load = modelUtils.getLoadingState(state, 'examTemplate')
    return {
      chapterInfo,
      saveExamReturn,
      examTemplateInfo,
      ...load
    }
  }

export default connect(mapStateToProps)

(
  ExamTemplateChapter
)
